import NavLinkListener from 'portal/services/NavLinkListener';
import NavBarDirective from 'portal/directives/NavBarDirective';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import 'edge/platform/widgets/pagestructure/module';
import 'edge/fnol/app';
import 'edge/faq/app';
import 'edge/claim/app';
import 'gw-portals-enrollment-angular';
import 'edge/platform/segmentation/module';
import 'edge/servicerequest/app';
import 'angularRouter';
import SetVersionDocumentTitle from 'gw-portals-platform-angular/versionName/SetVersionDocumentTitle';
// import 'edge/platform/widgets/footer/module';
import 'commonJsPath/edge/platform/uimetadata/module';
import 'commonJsPath/edge/api/gw-portals-driven-ui-angular/module';

import 'styles-portal/sass/modules.scss';
import '@uirouter/angularjs/lib/legacy/stateEvents.js';
import 'customerEdge/footer/module';


const modules = [
    'ui.router',
    'edge.platform.widgets.pagestructure',
    'edge.fnol.app',
    'edge.faq.app',
    'edge.claim.app',
    'edge.enrollment.app',
    'edge.platform.segmentation',
    'ui.router.state.events',
    'customerEdge.footer.module',
    'edge.platform.uimetadata',
    'edge.platform.metadataDrivenUI'
];
if (ApplicationFeatures.hasFeature('service-requests')) {
    modules.push('edge.servicerequest.app');
}

export default angular.module('portal.app', modules)
    .factory('NavLinkListener', NavLinkListener)
    .config(['FaqServiceProvider', (FaqServiceProvider) => {
        if (ApplicationFeatures.hasFeature('faq')) {
            let sections = [];
            try {
                const role = ApplicationFeatures.getAllFeatures().role[0];
                /*eslint-disable */
                // Webpack doesn't work well with template strings inside of require()
                const faqConfigForRole = require('portal/config/faq-' + role + '.json');
                /* eslint-enable */
                sections = faqConfigForRole.sections;
            } catch (e) {
                console.error(`Failed to load faq content: ${e}`);
            }

            FaqServiceProvider.setSections(sections);
        }
    }
    ])
    .config(['$locationProvider', ($locationProvider) => {
        $locationProvider.hashPrefix('');
    }])
    /**
    * Overrides printing a console error whenever a promise rejected and there’s no .catch block to handle that failure.
    * 
    * @param {Object} $qProvider the promise provider
    */
    .config(['$qProvider', ($qProvider) => {
        $qProvider.errorOnUnhandledRejections(false);
    }])

    .directive('gwPortalNavBar', NavBarDirective)

    .run(['$translate', ($translate) => {
        SetVersionDocumentTitle({
            $translate,
            // "portal.app.versionName.title[.${VERSION}]" l10n ID (with a version, if available for the app) will be used
            translationIdBase: 'portal.app.versionName.title'
        });
    }]);
